import axios from 'axios';

const api = axios.create({
  baseURL: '/',
  headers: {
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
  },
});

// Add CSRF token to all requests
api.interceptors.request.use((config) => {
  const token = document
    .querySelector('meta[name="csrf-token"]')
    ?.getAttribute('content');
  if (token) {
    config.headers['X-CSRF-TOKEN'] = token;
  }
  return config;
});

export const authApi = {
  login: (email, password) => api.post('/login', { email, password }),

  forgotPassword: (email) => api.post('/password/email', { email }),

  resetPassword: (data) =>
    api.post('/password/reset', {
      token: data.token,
      email: data.email,
      password: data.password,
      password_confirmation: data.passwordConfirmation,
    }),

  logout: () => api.post('/logout'),
};
